<template>
  <div class="default-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.default {
  &-container {
    padding: 28px;
  }
}
</style>
